import React from 'react';

import {Route, Routes, useLocation, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import Charger from "../Charger/cm";

import WhiteListManagement from "../WhiteListManagement";
import {Box, Button, Divider, MenuList, Stack, Toolbar} from "@mui/material";
import CollapsibleDrawer from "../../components/Common/Layout/CollapsibleDrawer";
import NavMenuItem from "../../components/Common/Layout/NavMenuItem";
import {useMenu} from "../../core/context/menuContext";
import AiTicketsDrawer from "../../components/AiTickets/AiTicketsDrawer";

import DashboardCM from "../Dashboard/cm";
import UserStatesCM from "../UserStates/cm";
import ChargeManagement from "../ChargeManagement/cm";
import PrefabsCm from "../Prefabs/cm/PrefabsCm";
import AllCmChargerLogs from "../ChargerLogs/cm/AllCmChargerLogs";
import ArchiveCM from "../Archive/cm/ArchiveCM";
import SearchBarCM from "../Search/SearchCM";
import AdvancedSearchCM from "../AdvancedSearch/AdvancedSearchCM";
import AnalyticsCM from "../Analytics/cm";
import ClansCM from "../Clans/cm";
import {ErrorBoundary} from "@sentry/react";
import CmPlayerEvents from "../PlayerEvents/cm/CmPlayerEvents";
import ArticleExporter from "../ArticleExporter/ArticleExporter";
import AnalyticalSearchCM from "../AnalyticalSearch/AnalyticalSearchCM"
import {MephistoProfile} from "../Profile/MephistoProfile";
import PersonalData from "../PersonalData";
import AiZendeskSettings from "../AiZendesk";
import AssistantChat from "../AssistantChat";
import SyncConflictsCM from "../SyncConflicts/cm";

export default function MainCM(props) {
    const {game, action} = useParams();
    const location = useLocation();

    const CommonData = useSelector((state) => state.data.CommonData)
    const mode = useSelector((state) => state.data.SourceMode)
    let deviceId = CommonData.deviceId ? CommonData.deviceId : '';
    let vendorId = CommonData.stateId ? CommonData.stateId : '';

    const dispatch = useDispatch();

    // expanded/collapsed by the burger button in the Header
    const {open: menuOpen} = useMenu()

    if (deviceId !== '' && deviceId !== CommonData.deviceId) {
        dispatch({
            type: "SET_DEVICE_ID",
            payload: {deviceId},
        });
    } else {
        if (typeof CommonData.deviceId == 'string') {
            deviceId = CommonData.deviceId
        }
    }


    const main_menu = [
        {
            to: `/${game}/assistant`,
            path: "assistant",
            title: "Assistant",
            element: <AssistantChat />,
            isDividerAfter:true
        },
        {
            to: '/' + game + '/dashboard/' + deviceId + '?vendorId=' +vendorId,
            path: 'dashboard/:deviceId?',
            title: 'Dashboard',
            element: <DashboardCM/>
        },
    ];
    const state_menu = [
        {
            to: '/' + game + '/state/' + deviceId + '?vendorId=' +vendorId,
            path: 'state/:deviceId?/:tab?/:subtab?',
            title: 'User State',
            element: <UserStatesCM/>,
            // disabled: deviceId == ''
        },
        {
            to: `/${game}/player-events/${deviceId}`,
            path: "player-events/:deviceId?/:tab?/:subtab?",
            title: "Player Events",
            element: <CmPlayerEvents />
        },
        {
            to: '/' + game + '/analytics/' + deviceId + '?vendorId=' +vendorId,
            path: 'analytics/:deviceId?/:tab?/:subtab?',
            title: 'Analytics',
            element: <AnalyticsCM/>,
            // disabled: deviceId == ''
        },
        {
            to: '/' + game + '/clans/' + deviceId + '?vendorId=' +vendorId,
            path: 'clans/:deviceId?/:tab?/:subtab?',
            title: 'Clans',
            element: <ClansCM/>,
            isDividerAfter:true

            // disabled: deviceId == ''
        },
        {to: '/' + game + '/charger/' + deviceId + '?vendorId=' +vendorId, path: 'charger/:deviceId?', title: 'Charger', element: <Charger/>},

        {to: '/' + game + '/logs', path: 'logs', title: 'ChargerLogs', element: <AllCmChargerLogs/>},
        //{to:'reports', title:'Reports',component:'<Reports />'},

    ]
    const common_menu = [
        {
            to: '/' + game + '/prefabs/' + deviceId + '?vendorId=' +vendorId,
            path: "prefabs/:deviceId?",
            title: 'Prefabs',
            element: <PrefabsCm game={game}/>
        },
        {
            to: '/' + game + '/archive/' + deviceId + '?vendorId=' +vendorId,
            path: "archive/:deviceId?",
            title: 'Archive',
            element: <ArchiveCM game={game}/>,
            isDividerAfter:true

        },
        {
            to: `/${game}/sync-conflicts`,
            path: "sync-conflicts",
            title: "Sync Conflicts",
            element: <SyncConflictsCM game={game} />
        },
        {
            to: '/' + game + '/search',
            path: "search",
            title: 'Search',
            element: <AdvancedSearchCM game={game}/>
        },
        {
            to: `/${game}/analytical-search`,
            path: "analytical-search",
            title: "Analytical Search",
            element: <AnalyticalSearchCM />
        },
        {
            to: `/${game}/profile/`+deviceId,
            path: "profile/:deviceId?",
            title: "Mephisto Profile",
            element: <MephistoProfile />,
            isDividerAfter:true

        }
    ]
    const admin_menu = [
        {
            to: '/' + game + '/chargeManagement',
            path: "chargeManagement",
            title: 'Charge Management',
            element: <ChargeManagement/>
        },
        {
            to: '/' + game + '/whitelistManagement',
            path: "whitelistManagement",
            title: 'White list management',
            element: <WhiteListManagement/>
        },
        {
            to: `/${game}/article-exporter`,
            path: "article-exporter",
            title: "Article Exporter",
            element: <ArticleExporter project={game} />
        },
        ...(mode.isProd ? [{
            to: `/${game}/personal-data`,
            path: "personal-data",
            title: "GDPR",
            element: <PersonalData initialProject="clock-maker" />
        }] : []),
        ...(mode.isProd ? [{
            to: `/${game}/ai-zendesk`,
            path: "ai-zendesk",
            title: "Zendesk",
            element: <AiZendeskSettings game={game} />
        }] : [])
    ]

    // first path segment ("dashboard/:deviceId?" -> "dashboard") matches the :action route param
    const isActive = (object) => object.path.split("/")[0] === action

    let menu = [
        ...main_menu,
        ...state_menu,
        ...common_menu
    ]


    const routes = (
        <Route>

            {menu.map((object) => (
                <Route path={object.path} element={object.element}/>
            ))}
            {admin_menu.map((object) => (
                <Route path={object.path} element={object.element}/>
            ))}
        </Route>
    );


    const ErrorFallback = ({ error, componentStack, resetError }) => (
        <Box sx={{pt:2}}>
            <h2>Error</h2>
            <p>{error.message}</p>
            <Button variant="contained" onClick={resetError} sx={{mb: 2}}>Try again</Button>
            <pre>{componentStack}</pre>
        </Box>
    );


    // Stack, not Box: App.css has a global ".MuiBox-root a" rule that would break the vertical menu
    return (
        <Stack direction="row" sx={{flexGrow: 1, minWidth: 0, width: "100%"}}>
            <CollapsibleDrawer anchor="left" width={230} open={menuOpen} label="menu" hideScrollbar>
                <MenuList>
                    {menu.map((object) => (
                        <React.Fragment key={object.path}>
                            <NavMenuItem {...object} open={menuOpen} selected={isActive(object)}/>
                            {object?.isDividerAfter && <Divider/>}
                        </React.Fragment>
                    ))}

                    {admin_menu.map((object) => (
                        <NavMenuItem key={object.path} {...object} open={menuOpen} selected={isActive(object)}/>
                    ))}
                </MenuList>
            </CollapsibleDrawer>
            <Box component="main"
                 sx={{flexGrow: 1, minWidth: 0, p: 3, display: "flex", flexDirection: "column"}}
            >
                <Toolbar/>

                {['chargeManagement', 'whitelistManagement','search', "analytical-search", "article-exporter", "sync-conflicts", "personal-data", "assistant", "ai-zendesk"].indexOf(action) == -1 &&
                    <Box
                        sx={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            mb: 2
                        }}>
                        <SearchBarCM />
                    </Box>
                }

                <ErrorBoundary key={`${game}/${action}`} fallback={ErrorFallback} >
                    <Box sx={{
                        width: "100%",
                        height: "100%"
                    }}>
                        <Routes>
                            {routes}
                        </Routes>
                    </Box>
                </ErrorBoundary>

            </Box>
            <AiTicketsDrawer/>
        </Stack>
    );
}
